import React from 'react'

const Header = ({ category, title }) => {
  return (
    <div className='mb-8'>
        <p className="text-xs font-semibold uppercase tracking-wider text-brand-600">{category}</p>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-gray-900 mt-1">
            {title}
        </h1>
    </div>
  )
}

export default Header
